import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getUserProfile,
  updateUserProfile,
  verifyNewEmail,
  getAmazonCredentials,
} from "../../services/apiV2";
import { TUser, TUserAmazonAccount } from "./user.types";
import { TVerifyNewEmailPayload } from "../../services/apiV2.types";
import { getUserProfilePhotoUrl } from "../../helpers";

export const getUserThunk = createAsyncThunk<TUser>(
  "user/getUserThunk",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getUserProfile();
      const { id, photoName } = res.data;
      return {
        ...res.data,
        photoName: getUserProfilePhotoUrl(id, photoName),
        growthMonthStarterPromo: true,
        growthAnnualOneTimePromo: true,
      };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async (payload: FormData, { rejectWithValue }) => {
    try {
      const res = await updateUserProfile(payload);
      const { id, photoName } = res.data;
      return {
        ...res.data,
        photoName: getUserProfilePhotoUrl(id, photoName),
      };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const getAmazonCredentialsThunk = createAsyncThunk<TUserAmazonAccount>(
  "user/getAmazonCredentials",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAmazonCredentials();
      const credentials = res.data;
      const realCredentials = credentials.filter(
        (c) => c.amazonAccountId !== null && c.isOAuthAuthorized,
      );
      const isConnected =
        realCredentials.length > 0 &&
        realCredentials.every(
          (c) => c.status === "connected" || c.status === "temporary_error",
        );
      const isValid = isConnected;
      return { isConnected, isValid, shouldShowModal: false };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const verifyUserNewEmail = createAsyncThunk(
  "user/verifyUserNewEmail",
  async (payload: TVerifyNewEmailPayload, { rejectWithValue }) => {
    try {
      await verifyNewEmail(payload);
      return payload.email;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
